<template>
    <!-- 班级信息 -->
    <div>
        <div class="conditionSearchBox">
            <div class="conditionItem">
                <el-input v-model="params.condition.name" placeholder="班级名称" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-button type="primary" plain icon="el-icon-search" @click="search">搜索</el-button>
                <el-button type="" icon="el-icon-refresh" @click="reset">重置</el-button>
            </div>
        </div>
        <el-table :data="tableData" border class="table-fixed-col" v-loading="contentLoading" ref="table">
            <el-table-column label="序号" :width="getTableHeaderWidthByOrderCol(isSelect)" fixed align="center" key="sort">
                <template slot-scope="scope">
                    <TableSort :index="scope.$index" :page="params.page" :pagesize="params.pagesize" />
                </template>
            </el-table-column>
            <el-table-column prop="name" label="班级名称" align="center" min-width="200" key="name" fixed show-overflow-tooltip>
                <template slot-scope="scope">
                    <p class="pointer color-brand text-ellipse" @click="goDetail(scope.row)">{{scope.row.name}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="totalcoursecount" label="课程总数" align="center" width="150" key="totalcoursecount"></el-table-column>
            <el-table-column prop="totalscore" label="总学分数" align="center" width="150" key="totalscore"></el-table-column>
            <el-table-column prop="datetime" label="上课时间" align="center" width="200" key="datetime">
                <template slot-scope="scope">
                    <p>{{scope.row.begindate + '~' + scope.row.enddate}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="finishperiodcount" label="已上课/排课数" align="center" width="150" key="finishperiodcount">
                <template slot-scope="scope">
                    <p>{{scope.row.finishperiodcount + '/' + scope.row.totalperiodcount}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="statusname" label="结业状态" align="center" width="100" key="statusname"></el-table-column>
        </el-table>
        <Page v-if="total > 0" @pageChange="pageChange" @pagesizeChange="pagesizeChange" :total="total" :page="params.page" :pagesize="params.pagesize" />
    </div>
</template>
<script>
import { getTableDefaultPageSize } from '@/assets/measAssets/js/tools.js'
import TableSort from '@/components/measComponents/tableSort/tableSort.vue'
import Page from '@/components/measComponents/page/page.vue'
import { getStudentClassList } from '@/api/measApi/studentManage.js'
export default {
  data() {
    return {
      params: {
        condition: {
          code: '',
          name: ''
        },
        page: 1,
        pagesize: getTableDefaultPageSize()
      },
      contentLoading: false,
      tableData: [],
      total: 0,
      isSelect: false
    }
  },
  props: {
    code: {
      type: String,
      required: true
    },
    classCode: {
      type: String
    }
  },
  components: {
    TableSort,
    Page
  },
  created() {
    if (!this.classCode) {
      this.params.condition.code = this.code
      this.getStudentClassList()
    }
  },
  methods: {
    //   获取班级列表
    getStudentClassList() {
      this.contentLoading = true
      getStudentClassList(this.params).then(res => {
        if (res.code === '000') {
          this.tableData = res.data
          this.total = res.pageinfo.rowcount
          this.contentLoading = false
        }
      })
    },
    // 搜索
    search() {
      this.params.page = 1
      this.getStudentClassList()
    },
    // 重置
    reset() {
      this.params = {
        condition: {
          code: this.code,
          name: ''
        },
        orderbyname: '',
        orderbyorder: '',
        page: 1,
        pagesize: getTableDefaultPageSize()
      }
      this.getStudentClassList()
    },
    // 分页
    pageChange(page) {
      this.params.page = page
      this.getStudentClassList()
    },
    pagesizeChange(size) {
      this.params.page = 1
      this.params.pagesize = size
      this.getStudentClassList()
    },
    goDetail(value) {
      this.$router.push({ name: 'ClassDetail', query: { code: value.code } })
    }
  }
}
</script>
